/**
 * Orvi Script Loader - Simple approach for reliable form handling
 * Disables complex form manager to prevent conflicts
 */

(function() {
  'use strict';
  
  // Disable the complex form manager to prevent conflicts
  window.OrviFormManager = {
    registerFormHandler: function() { return false; },
    isFormHandled: function() { return false; },
    markFormHandled: function() { return false; },
    removeFormHandler: function() { return false; },
    detectFormType: function() { return null; },
    getFormId: function() { return null; },
    checkElementConflicts: function() { return false; },
    cleanupDuplicateHandlers: function() { return false; },
    getActiveHandlers: function() { return []; }
  };
  
  // Simple ready state tracking
  window.OrviScriptLoader = {
    isReady: function() { return true; },
    loaded: { simpleHandler: false },
    markLoaded: function(name) { this.loaded[name] = true; }
  };
  
  console.log('Orvi: Using simple form handler approach');
  
})();
